<template>
  <div>
    <div class="title" style="display: flex;align-content: space-between;">
      <h3 style="flex:1;">
        {{$t('dashboard.tokens.title')}}
      </h3>
      <h3 style="flex:1;text-align: right;">🏦 {{$t('dashboard.tokens.my_tokens')}}: {{balance}}</h3>
    </div>
    <ResourceTable
      :resource="TokenTransactionsTable.resource"
      :params="TokenTransactionsTable.options"
      :perPage="per_page"
    >
      <template slot="header">
        <th>
          {{$t('dashboard.tokens.table.date')}}
        </th>
        <th>
          {{$t('dashboard.tokens.table.description')}}
        </th>
        <th>
          {{$t('dashboard.tokens.table.operation')}}
        </th>
      </template>
      <template slot-scope="{element}">
        <td style="text-align: center;">
          {{$d(new Date(element.created_at), 'short')}}
        </td>
        <td>
          {{element.description}}
        </td>
        <td style="text-align: right;">
          {{formatTokens(element.operation)}}
        </td>
      </template>
      <template slot="responsive_card_{element}" slot-scope="{element}">
        <div class="card">
          <div style="display: flex;margin:1rem 0;align-items: center;">
            <div style="flex: 1">{{$d(new Date(element.created_at), 'short')}}</div>
            <div style="flex: 1;border-radius:0.5rem;padding: 0.3rem 0.5rem;font-weight: bold;font-size: 0.9rem;" :class="element.latest_payment_status">{{element.description}}</div>
            <div class="amount">💰 {{element.operation}}</div>
          </div>
        </div>
      </template>
      <template slot="empty">
        {{$t('noRecords')}}
      </template>
    </ResourceTable>
  </div>
</template>
<script>
import ResourceTable from "../components/ResourceTable"
import resources from "../resources";

export default {
  name: 'TokenTransactionsTable',
  components: {ResourceTable},
  computed: {
      TokenTransactionsTable(){
      return {
        resource: resources.tokens,
        options: {
          order_by: [['created_at', 'desc']],
          user_id: this.$auth.user().id,
        },
      };
    },
  },
  data(){
    return {
      balance: 0,
      per_page: process.env.VUE_APP_PER_PAGE
    }
  },
  methods: {
    getTokensBalance() {
			resources.tokensBalance.index({}).then((response) => {
				this.balance = response.data.data.balance;
			});
      // let readBaseUrl = process.env.VUE_APP_ROOT_API.replace(/\/+$/, "");
      // this.$http.get(readBaseUrl+'/tokens/balance')
      //     .then(data => {
      //       this.balance = data.body.data.balance;
      //     });
    },
    formatTokens(value) {
      return parseInt(value).toFixed(0);
    }
  },
  mounted() {
    this.getTokensBalance();
    console.log('mounted');
  }
}
</script>
<style scoped lang="scss">
@import '../styles/variables';
.card {
  border-radius: 1rem;
  margin-bottom: 1rem;
  background-color: #131111;
  padding: 0.5rem 1rem;
  box-shadow: inset #ff4545 0px 0px 5px 0px;
  box-shadow: inset #000000 0px 0px 4px 0px;
  background-color: rgba(125, 125, 125, 0.5);
  font-weight: bold;

  & .amount {
    background-color:#454545;
    border-radius:0.5rem;
    padding: 0.3rem 0.5rem;
    font-weight: bold;
    font-size: 0.9rem;
    background-color: black;
  }
}
</style>